import { UniqueRandomGenerator } from '@/tools/UniqueRandomGenerator';

interface RangeToolsType {
  getRandomIntegerInRange(min: number, max: number): number;
  getRandomFloatInRange(min: number, max: number): number;
  randomInRange(min: number, max: number): number;
  createUniqueRandomGenerator(): UniqueRandomGenerator;
  getRandomCharacter(): string;
}

export default class RangeTools implements RangeToolsType {
  getRandomIntegerInRange(min: number, max: number): number {
    min = +min; // Ensure min and max are treated as numbers
    max = +max;
    if (!this.validateRangeInputs(min, max)) {
      return NaN; // Return NaN to indicate an error condition
    }
    // Get and return a random integer within the range
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  getRandomFloatInRange(min: number, max: number): number {
    min = +min; // Ensure min and max are treated as numbers
    max = +max;
    if (!this.validateRangeInputs(min, max)) {
      return NaN; // Return NaN to indicate an error condition
    }
    // Get and return a random float within the range
    return Math.random() * (max - min) + min;
  }

  private validateRangeInputs(min: number, max: number): boolean {
    if (!Number.isFinite(min) || !Number.isFinite(max)) {
      console.error('Error: Min and max must be finite numbers.');
      return false;
    }
    if (isNaN(min) || isNaN(max)) {
      console.error('Error: Min and max must be numbers.');
      return false;
    }
    if (min > max) {
      console.error('Error: Min cannot be greater than max.');
      return false;
    }
    return true; // Inputs are valid
  }

  randomInRange(min: number, max: number): number {
    const randomNum = Math.random() * (max - min) + min;
    return Math.floor(randomNum);
  }

  /**
   * Returns an instance of the UniqueRandomGenerator class
   * @returns {UniqueRandomGenerator}
   */
  createUniqueRandomGenerator(): UniqueRandomGenerator {
    return new UniqueRandomGenerator();
  }

  /**
   * Get a random character from the alphabet
   * @returns {string}
   */
  getRandomCharacter(): string {
    return String.fromCharCode(this.getRandomIntegerInRange(65, 90));
  }
}
